import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import moment from 'moment-timezone';
import styles from './Timeline.module.scss';
import classNames from 'classnames';
import { getActivityColor } from './Timeline.helper';
import { formatPercent } from '@/utils/numberUtils';
import { formatTimeFromSeconds } from '@/utils/timeUtils';
import { normalizeIdleForDisplay } from '@/utils/idleDisplayUtils';
import { SessionSourceTags } from '@/components/SessionSourceTags';
export const timelineTableConfig = ({
  selectedTimezone,
  openScreenshotsModal,
  dayLabel,
}) => [
  {
    id: 'startEndTime',
    name: 'START TIME - END TIME',
    sortable: false,
    cellRenderer: (row) => {
      const start = moment(row.start).tz(selectedTimezone).format('hh:mm A');
      const end = moment(row.end).tz(selectedTimezone).format('hh:mm A');

      return (
        <div className={styles.startEndCell}>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
            className={styles.tableCell}
          >
            {start} - {end}
          </Text>
          <SessionSourceTags
            pastData={row?.pastData}
            typeLog={row?.typeLog}
            textVariant={textVariantsEnum.Text_xs}
          />
        </div>
      );
    },
  },
  {
    id: 'totalTimeTracked',
    name: 'TOTAL TIME TRACKED',
    sortable: false,
    cellRenderer: (row) => {
      return (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
          className={styles.tableCell}
        >
          {formatTimeFromSeconds(row.durationSec)}
        </Text>
      );
    },
  },
  {
    id: 'prodctivityScore',
    name: 'PRODUCTIVITY SCORE',
    sortable: false,
    cellRenderer: (row) => {
      const badgeColor = getActivityColor(row.activityPct, false);
      return (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
          className={classNames(
            styles.tableCell,
            styles.badge,
            styles[`badge_${badgeColor}`]
          )}
        >
          {formatPercent(row.activityPct)}
        </Text>
      );
    },
  },
  {
    id: 'idelRest',
    name: 'IDLE/REST',
    sortable: false,
    cellRenderer: (row) => {
      const { displayIdle } = normalizeIdleForDisplay(
        row.durationSec,
        row.idleSec
      );
      return (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
          className={styles.tableCell}
        >
          {formatTimeFromSeconds(displayIdle)}
        </Text>
      );
    },
  },
  {
    id: 'idelpct',
    name: 'IDLE %',
    sortable: false,
    cellRenderer: (row) => {
      const { idlePercent: idlePct } = normalizeIdleForDisplay(
        row.durationSec,
        row.idleSec
      );
      return (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
          className={styles.tableCell}
        >
          {formatPercent(idlePct)}
        </Text>
      );
    },
  },
  {
    id: 'screenshots',
    name: 'SCREENSHOTS',
    sortable: false,
    cellRenderer: (row) => {
      return (
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
          className={classNames(styles.tableCell, styles.viewButton)}
          onClick={() =>
            openScreenshotsModal(
              { ...row, id: row.parentSessionId || row.id },
              dayLabel
            )
          }
        >
          {'View'}
        </Text>
      );
    },
  },
];
